
import { Navigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { checkTokenValidity } from "../utils/auth";
import { useEffect } from "react";
import TokenExpiredModal from "./TokenExpiredModal/TokenExpiredModal";
import { useTokenExpiration } from "../context/TokenExpirationContext";
const ProtectedRoute = ({ children }) => {
  const { showExpiredModal, handleTokenExpired, handleLoginRedirect, setShowExpiredModal } = useTokenExpiration();
  const location = useLocation();
  const isLoginPage = location.pathname === '/';


  useEffect(() => {
    window.scrollTo(0,0);
  }, [location])

  if (!checkTokenValidity() && !isLoginPage) {

    const token = localStorage.getItem("admin_token");
    if (!token) {
      return <Navigate to="/" replace />;
    }
    else {
      setShowExpiredModal(true);
    }
  }
  return children;
};

export default ProtectedRoute;
